import React from 'react';
import "./SportOneWeAreW18.scss";

const SportOneWeAreW18 = () => {
    return (
        <section className="sport-one-weAreW18">
            <div className="weAreW18-container">
                <img
                    src="/assets/img/sports/sport-one/images/W18.png"
                    alt="We Are W18"
                    className="weAreW18-banner"
                />
                <div className="weAreW18-text">
                    <p>
                        At W18 Sports Universe, we make sports training fun,<br />
                        fitness programs inspiring, and youth talent shine brighter.<br />
                        Mental strength, movement, and mastery – all in one place.<br />
                        <span className="hashtag">#BreakASweatTheRightWay</span>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default SportOneWeAreW18;
